import { createPatchEndpoint } from '@sonar-software/sonar-http';

export type PatchOrganizationRequest = {
	dailySyncEnabled?: boolean;
	name?: string;
	organizationId: number;
	packageTagEnabled?: boolean;
};

export const patchOrganization = createPatchEndpoint<PatchOrganizationRequest>('/api/v3/core/organizations');
